import { sanitizeFileName } from '../../Scaap/utils/xlsx/miniXlsx';
import { labelCentro } from '../../../features/labels/labels';
export const getCenters = async (servidor) => {
  try {
    const response = await fetch(`${servidor}/flux/get_centers`, {
      method: 'POST',
      credentials:'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    const data = await response.json();

    // Extrae solo el array
    return data?.IDs?.flux?.barcos || [];
  } catch (error) {
    console.error('getCenters error:', error);
    return [];
  }
};



export const getData = async (servidor) => {

  const barco = localStorage.getItem('CENTRO')

  try {
    const response = await fetch(`${servidor}/flux/get_data/Flux/Barcos/${barco}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      keepalive: false
    
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('get_data error:', error);
    throw error;
  }
};



export const getDataByCenter = async (servidor, barco) => {
  try {
    const response = await fetch(
      `${servidor}/flux/get_data/Flux/Barcos/${barco}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`getDataByCenter error (${barco}):`, error);
    return null; // importante para que Dashboard no se rompa
  }
};


export const generateReport = async (servidor, FECHA_INICIO, FECHA_FIN) => {
  const barco = localStorage.getItem('CENTRO');
  console.log("barco a solicitar", barco)

 
  const [d_ini, m_ini, y_ini] = FECHA_INICIO.split('/');
  const fecha_inicio_dashed = `${y_ini}-${m_ini}-${d_ini}`;

  const [d_fin, m_fin, y_fin] = FECHA_FIN.split('/');
  const fecha_fin_dashed =  `${y_fin}-${m_fin}-${d_fin}`;

  console.log(`${servidor}/flux/generate_report/${barco}/${FECHA_INICIO}/${FECHA_FIN}`)

  console.log(fecha_inicio_dashed, fecha_fin_dashed)
  console.log(`${servidor}/flux/generate_report/${barco}/${fecha_inicio_dashed}/${fecha_fin_dashed}`)


  try {
    const response = await fetch(
      `${servidor}/flux/generate_report/${barco}/${fecha_inicio_dashed}/${fecha_fin_dashed}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error(errorData?.mensaje || `Error ${response.status}`);
    }

    // 👇 IMPORTANTE
    const blob = await response.blob();

    // Crear descarga
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const label = labelCentro({ region: "flux", area: "barcos", centro: barco }, '');
    link.download = `Reporte_Flux_${label ? sanitizeFileName(label) : barco}_${FECHA_INICIO}_${FECHA_FIN}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    return { success: true };

  } catch (error) {
    console.error('generateReport error:', error);
    return { error: true, message: error.message };
  }
};
